<div class="logo">
  <img [src]="logo" alt="" />
</div>

<div class="label">
  {{ brand.name }}
</div>

<div *ngIf="!!brand.website" class="website">
  {{ brand.website | ensureUrlProtocol }}
</div>
